import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {OrganisationRepository} from '../repositories/organisation.repository';
import {OrganisationStore} from '../stores/organisation.store';

export const managedPracticeGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const orgStore = inject(OrganisationStore);
  const repo = inject(OrganisationRepository);
  const router = inject(Router);

  const practiceId = Number(route.paramMap.get('practiceId'));
  const orgId = orgStore.selectedOrganisationId();
  const fallback = router.createUrlTree(['/management/practices']);

  if (!orgId || !practiceId) {
    return fallback;
  }

  return repo.getOrganisationPractices(orgId).pipe(
    map(practices => {
      const practice = practices.find(p => p.practiceId === practiceId);
      return practice?.isManaged ? true : fallback;
    }),
    catchError(() => of(fallback))
  );
};
